import { z } from 'zod';

const StageTransactionSimulationEnvSchema = z.object({
  ENVIRONMENT: z.literal('STAGE'),
  TENDERLY_TESTNET_RPC_URL: z.string().optional(),
  TENDERLY_ETHEREUM_FORK_RPC_URL: z.string().optional(),
  TENDERLY_ETHEREUM_CONTRACT_DEPLOYMENT_FORK_RPC_URL: z.string().optional(),
  TENDERLY_BASE_FORK_RPC_URL: z.string().optional(),
  TENDERLY_ARBITRUM_FORK_RPC_URL: z.string().optional(),
  TENDERLY_RONIN_FORK_RPC_URL: z.string().optional(),
});

const ProductionTransactionSimulationEnvSchema = z.object({
  ENVIRONMENT: z.literal('PROD'),
  TENDERLY_ACCESS_TOKEN: z.string().optional(),
  TENDERLY_PROJECT_SLUG: z.string().optional(),
  TENDERLY_USER: z.string().optional(),
});

const TransactionSimulationEnvSchema = z.discriminatedUnion('ENVIRONMENT', [
  StageTransactionSimulationEnvSchema,
  ProductionTransactionSimulationEnvSchema,
]);

type TransactionSimulationEnv = z.infer<typeof TransactionSimulationEnvSchema>;

/**
 * Return only the Tenderly settings authorized for the current live environment.
 * Stage owns stateful VNet URLs, Prod owns Classic API credentials, and every
 * other environment leaves live provider simulation unconfigured.
 */
export function getTransactionSimulationEnvVariables():
  | TransactionSimulationEnv
  | undefined {
  const parsed = TransactionSimulationEnvSchema.safeParse(process.env);
  return parsed.success ? parsed.data : undefined;
}
